import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { PagesPolicyDialogLinksPagesComponent } from './dialogs/links/pages/pages-policy-dialog-links-pages.component';
import { PagesPolicyDialogLinksComponent } from './dialogs/links/pages-policy-dialog-links.component';
import { PagesPolicyDialogPagesComponent } from './dialogs/pages/pages-policy-dialog-pages.component';
import { PagesPolicyPagesComponent } from './pages/pages-policy-pages.component';
import { PagesPolicyIgnoredPagesComponent } from './pages-with-ignored-checks/pages-with-ignored-checks.component';
import { PolicyPoliciesComponent } from './policies/policies.component';
import { ExportModule } from '@client/app/modules/export/export.module';
import {
    LabelModule,
    LayoutModule,
    MonEventTriggerModule,
    MonTableSortModule,
} from '@monsido/angular-shared-components';
import {
    QuickHelpComplianceStatusModule,
} from '@client/app/components/quick-help-compliance-status/quick-help-compliance-status.module';
import { ExtensionModule } from '@client/app/modules/extension/extension.module';
import { PolicyDistributionComponent } from './policy/distribution/distribution.component';
import { PolicyLastScanComponent } from './policy/last-scan/last-scan.component';
import { PolicyPriorityComponent } from './policy/priority/priority.component';
import { TablePolicyTypeComponent } from '@monsido/modules/table-policy-type/table-policy-type.component';
import { MonActionMenuModule } from '@client/ng2/shared/components/action-menu/action-menu.module';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';
import { BarComponent } from '@client/app/modules/charts/components/bar.component';
import { PagesPolicyComponent } from './pages-policy.component';
import { UIRouterModule } from '@uirouter/angular';
import { ActiveFeaturePipe } from '@monsido/core/pipes/active-feature/active-feature.pipe';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        UpgradePipeModule,
        TranslateModule,
        NgbTooltipModule,
        ExportModule,
        LayoutModule,
        QuickHelpComplianceStatusModule,
        MonTableSortModule,
        LabelModule,
        ExtensionModule,
        MonEventTriggerModule,
        TablePolicyTypeComponent,
        MonActionMenuModule,
        ModalsDirectivesModule,
        BarComponent,
        UIRouterModule,
        ActiveFeaturePipe,
    ],
    exports: [],
    declarations: [
        PagesPolicyDialogLinksPagesComponent,
        PagesPolicyDialogLinksComponent,
        PagesPolicyDialogPagesComponent,
        PagesPolicyPagesComponent,
        PagesPolicyIgnoredPagesComponent,
        PolicyPoliciesComponent,
        PolicyDistributionComponent,
        PolicyLastScanComponent,
        PolicyPriorityComponent,
        PagesPolicyComponent,
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UpgradePolicyModule {}
